/* __next_internal_client_entry_do_not_use__ maybeAddCTATile,shouldAddCTATile,CTATile auto */ import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Arrow } from "@faire/web--source/slate/icons/foundation/Arrow";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import React from "react";
// eslint-disable-next-line import/no-unassigned-import
import "./native-styles.css";
export var maybeAddCTATile = function(arr, data, itemsPerSlide) {
    if (shouldAddCTATile(arr, data, itemsPerSlide) && isNotUndefined(data)) {
        return _to_consumable_array(arr).concat([
            /*#__PURE__*/ _jsx(CTATile, {
                data: data
            }, "cta-tile")
        ]);
    } else {
        return arr;
    }
};
export var shouldAddCTATile = function(arr, data, itemsPerSlide) {
    return isNotUndefined(data) && (arr.length > itemsPerSlide || data.alwaysVisible);
};
export var CTATile = function(param) {
    var data = param.data;
    return /*#__PURE__*/ _jsxs(Link, {
        className: "f_c_cta_tile_wrapper",
        to: data.linkTo,
        onClick: data.onClick,
        "data-test-id": "cta-tile-wrapper",
        children: [
            /*#__PURE__*/ _jsx(Row, {
                className: "f_c_cta_tile_icon_wrapper",
                align: "center",
                justify: "center",
                children: /*#__PURE__*/ _jsx(Arrow, {
                    direction: "right",
                    fontSize: "32px"
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansMedium",
                align: "center",
                children: data.text
            })
        ]
    });
};
